import { createAction, props } from '@ngrx/store';

export const hasOnBoarded = createAction('[App State] Has On Board');

export const updateSessionId = createAction(
  '[App State] Update Session Id',
  props<{ sessionId: string }>()
);
